import { render, staticRenderFns } from "./userDashboardTerminationDialog.vue?vue&type=template&id=bfe683b2&scoped=true"
import script from "./userDashboardTerminationDialog.vue?vue&type=script&lang=js"
export * from "./userDashboardTerminationDialog.vue?vue&type=script&lang=js"
import style0 from "./userDashboardTerminationDialog.vue?vue&type=style&index=0&id=bfe683b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe683b2",
  null
  
)

export default component.exports